import React from 'react';
import { useParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconReactionPositiveSmall } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { SlDiscussContext } from '../../global-constants';
import { ActionType, RequestType } from '../../global-interface';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { getQuestionAlias } from '../../utils/helpers';
import { useComponentWillMount } from '../../../../shared/public/SlUtils/useComponentWillMount';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { LocalizedLink } from '../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './HotToday.scss';

export function HotToday() {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	const { id } = useParams();

	useComponentWillMount(() => {
		actions$.next({
			type: ActionType.OnHotTodayMount,
			requestType: RequestType.Parallel,
		});
	});

	const { hotTodayTopics$: hotTodayTopics } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['hotTodayTopics$'],
	);

	const onTopicClick = (topicId: number) => {
		actions$.next({
			type: ActionType.OnTopicClick,
			requestType: RequestType.Parallel,
			data: {
				id: topicId,
				pageAlias: id === 'New' ? 'ASK A QUESTION' : 'discuss',
			},
		});
	};

	return (
		<div className="discuss-hot-today">
			<div className="discuss-hot-today__title">
				{i18n.t('web-discuss.hot-today-title')}
			</div>
			{hotTodayTopics
				? hotTodayTopics.map((hotTodayTopic) => (
					<div
						className="discuss-hot-today__topic"
						key={hotTodayTopic.id}
					>
						<LocalizedLink
							to={`/Discuss/${hotTodayTopic.id
							}/${getQuestionAlias(hotTodayTopic.title)}`}
							className="discuss-hot-today__topic__title"
							onClick={() => onTopicClick(hotTodayTopic.id)}
						>
							{hotTodayTopic.title}
						</LocalizedLink>
						<div className="discuss-hot-today__topic__votes">
							<IconReactionPositiveSmall />
							{' '}
							{hotTodayTopic.votes}
							{' '}
							Votes
						</div>
					</div>
				))
				: null}
		</div>
	);
}
